import { Link } from 'react-router-dom';
import { events, siteStats } from '@/mocks/events';

const heroImg =
  'https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20a%20warm%20media%20newsroom%20tracking%20trending%20events%2C%20polaroid%20photo%20cards%20pinned%20on%20a%20warm%20cream%20corkboard%20connected%20by%20terracotta%20thread%20lines%20forming%20a%20timeline%2C%20soft%20window%20light%2C%20cozy%20storyteller%20atmosphere%2C%20cream%20beige%20and%20vermilion%20palette%2C%20scattered%20notepaper%2C%20high%20detail%20editorial%20photography%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=hero-guaji-01&orientation=landscape';

export default function Hero() {
  const liveCount = events.filter((e) => e.status === '发酵中').length;
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImg} alt="吃瓜事件时间轴追更追踪编辑风背景" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-background-50" />
      </div>
      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center px-4 pb-24 pt-20 text-center md:px-6 md:pb-32 md:pt-28">
        <span className="fade-up inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/30 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          <span className="h-2 w-2 rounded-full bg-accent-400 pulse-dot" />
          吃瓜事件时间轴 · 持续更新中
        </span>
        <h1 className="fade-up mt-6 font-heading text-3xl font-semibold leading-snug text-background-50 sm:text-4xl md:text-5xl md:leading-snug" style={{ animationDelay: '0.05s' }}>
          热点事件别错过 <br className="sm:hidden" />
          按节点看清<em className="not-italic text-accent-400">来龙去脉</em>
        </h1>
        <p className="fade-up mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base" style={{ animationDelay: '0.12s' }}>
          瓜迹把每起吃瓜事件的经过与进展整理成清晰时间轴，从爆发、发酵到官方回应与后续追踪，一条线看清事件如何一步步演变，追更不迷路。
        </p>
        <div className="fade-up mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" style={{ animationDelay: '0.18s' }}>
          <Link
            to="/events"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-focus-3-line text-lg" /> 查看事件时间轴
          </Link>
          <Link
            to="#live"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-black/25 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/10"
          >
            <i className="ri-flashlight-line text-lg text-accent-300" /> 正在发酵 {liveCount} 起
          </Link>
        </div>
        <div className="fade-up mt-10 flex items-center justify-center gap-6 text-center md:gap-10" style={{ animationDelay: '0.24s' }}>
          {[
            { v: `${siteStats.events}+`, k: '已收录事件' },
            { v: `${siteStats.nodes}+`, k: '时间轴节点' },
            { v: `${siteStats.categories}类`, k: '热点栏目' },
            { v: `今日+${siteStats.updates}`, k: '最新进展' },
          ].map((s) => (
            <div key={s.k} className="flex flex-col items-center">
              <span className="font-heading text-2xl font-semibold text-accent-300 md:text-3xl">{s.v}</span>
              <span className="mt-1 text-xs text-background-100/80">{s.k}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}